<template>
  <div id="contenedor-main-licitacion-visita-obra">
    <listado />
  </div>
</template>

<script>
import Listado from './listado/Main.vue';

export default {
  name: 'MainLicitacionVisitaObra',
  components: {
    Listado,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
